import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { apiClient, formatDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ChangePasswordDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (pw.length < 6) return toast.error("Password baru minimal 6 karakter");
    if (pw !== pw2) return toast.error("Konfirmasi password tidak cocok");
    setBusy(true);
    try {
      await apiClient.post("/auth/change-password", { current_password: cur, new_password: pw });
      toast.success("Password berhasil diubah");
      setCur(""); setPw(""); setPw2(""); setOpen(false);
    } catch (e) {
      toast.error(formatDetail(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger || <Button variant="ghost" size="sm"><KeyRound className="w-4 h-4 mr-2"/> Ubah Password</Button>}</DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Ubah Kata Sandi</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label className="text-xs">Password Saat Ini</Label><Input type="password" value={cur} onChange={(e)=>setCur(e.target.value)} autoComplete="current-password" data-testid="cp-current"/></div>
          <div><Label className="text-xs">Password Baru</Label><Input type="password" value={pw} onChange={(e)=>setPw(e.target.value)} autoComplete="new-password" data-testid="cp-new"/></div>
          <div><Label className="text-xs">Konfirmasi Password Baru</Label><Input type="password" value={pw2} onChange={(e)=>setPw2(e.target.value)} autoComplete="new-password" data-testid="cp-confirm"/></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={()=>setOpen(false)}>Batal</Button>
          <Button className="bg-[#00A651] hover:bg-[#008741]" onClick={submit} disabled={busy} data-testid="cp-submit">Simpan</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
